import { render, staticRenderFns } from "./BoxWithHeader.vue?vue&type=template&id=57d64a51&scoped=true"
import script from "./BoxWithHeader.vue?vue&type=script&lang=js"
export * from "./BoxWithHeader.vue?vue&type=script&lang=js"
import style0 from "./BoxWithHeader.vue?vue&type=style&index=0&id=57d64a51&prod&scoped=true&lang=css"
import style1 from "./BoxWithHeader.vue?vue&type=style&index=1&id=57d64a51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d64a51",
  null
  
)

export default component.exports